export enum DownloadCategory {
  System = "system",
}
